import "../../../assets/css/font.css.ts.vanilla.mjs";
import "./ReoSelect.css.ts.vanilla.mjs";
var _ = "p273__ReoSelect-cee3_a86fa1a__e2iamca", c = { large: [0, 6], medium: [0, 4], small: [0, 4] }, l = { large: "p273__ReoSelect-cee3_a86fa1a__e2iamc7", medium: "p273__ReoSelect-cee3_a86fa1a__e2iamc8", small: "p273__ReoSelect-cee3_a86fa1a__e2iamc9" }, o = "p273__ReoSelect-cee3_a86fa1a__e2iamc6", m = "p273__ReoSelect-cee3_a86fa1a__e2iamcd", p = "p273__ReoSelect-cee3_a86fa1a__e2iamcc", r = "p273__ReoSelect-cee3_a86fa1a__e2iamc4", i = "p273__ReoSelect-cee3_a86fa1a__e2iamc5", t = "p273__ReoSelect-cee3_a86fa1a__e2iamcb", f = "p273__ReoSelect-cee3_a86fa1a__e2iamc3", S = { large: "p273__ReoSelect-cee3_a86fa1a__e2iamc0", medium: "p273__ReoSelect-cee3_a86fa1a__e2iamc1", small: "p273__ReoSelect-cee3_a86fa1a__e2iamc2" };
export {
  _ as dropDown,
  c as dropdownOffset,
  l as dropdownSizeMap,
  o as icon,
  m as labelForSelect,
  p as required,
  r as search,
  i as select,
  t as selectInPopup,
  f as selectWrap,
  S as sizeMap
};
//# sourceMappingURL=ReoSelect.mjs.map
